import { AdvancedSecurityOption } from 'owa-security-advanced-option';
import { AccountSecurityOption } from 'owa-security-account-option';
var premiumDashboardSecuritySubCategory = {
    key: 'security',
    titleStringKey: 'options_premiumSubOption_Security',
    options: [AccountSecurityOption, AdvancedSecurityOption],
};
export default premiumDashboardSecuritySubCategory;
//# sourceMappingURL=PremiumDashboardSecuritySubCategory.js.map